// T6 do backlog de conversao (programa de indicacao). O codigo chega na URL
// de chegada (?ref=<codigo>, gerado a partir do link de quem indicou - ver
// api/referral/code.js no backend) e precisa sobreviver ate a pessoa
// realmente assinar, o que pode levar varias visitas/dias - por isso fica
// salvo no navegador, nao só em memória da página atual.
const STORAGE_KEY = "qa_referral_code";

export function captureReferralCodeFromUrl(search) {
  try {
    const params = new URLSearchParams(search ?? window.location.search);
    const code = params.get("ref");
    // So grava quando um codigo novo chega - navegar por outras paginas sem
    // ?ref não pode apagar uma indicação já capturada antes.
    if (code) {
      window.localStorage.setItem(STORAGE_KEY, code);
    }
  } catch {
    // Storage bloqueado (aba anônima etc.) - a indicação só não vale nessa
    // visita, nada na navegação quebra por causa disso.
  }
}

export function getStoredReferralCode() {
  try {
    return window.localStorage.getItem(STORAGE_KEY) || null;
  } catch {
    return null;
  }
}
